import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=25d6aa2d&scoped=true&lang=pug&"
import script from "./Chatbot.vue?vue&type=script&lang=js&"
export * from "./Chatbot.vue?vue&type=script&lang=js&"
import style0 from "./Chatbot.vue?vue&type=style&index=0&id=25d6aa2d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d6aa2d",
  null
  
)

/* custom blocks */
import block0 from "./Chatbot.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports